import { ohlq } from "./ohlq";
import { vermont } from "./vermont";

const connections = [ohlq, vermont];
export default connections;
